import CTALink from "@components/elements/CTALink"
import BarsIcon from "@components/icons/BarsIcon"
import CloseIcon from "@components/icons/CloseIcon"
import { capitalize, isEmpty } from "lodash"
import React, { useState, useEffect, useRef } from "react"
import { Accordion, Offcanvas } from "react-bootstrap"
import logoWhite from "@images/logo-white.svg"
import logo from "@images/logo.svg"
import "./BurgerMenu.scss"
import { Link } from "gatsby"
import { useGlobalStore } from "@stores/globalStore"
import { CurrencyTypeSelect, LanguageTypeSelect } from "@components/SearchResults/SearchFilters/filterElements"
import useDeviceMedia from "@hooks/useDeviceMedia"
import SizeTypeSelector from "@components/SizeTypeSelector/SizeTypeSelector"
import { getUser } from "@starberry/myaccount-website-utils"
import UserIcon from "@components/icons/UserIcon"
import UserIconLogged from "@components/icons/UserIconLogged"

const BurgerMenu = ({ links, showModal, setShowModal, whiteIcon, propssetTog, isTransparent, transparentScroll, isAuthenticated }) => {
  if (!links) return null
  const userData = getUser();
  const { isMobile } = useDeviceMedia()
  const { currencyType, language } = useGlobalStore()
  const [tog, setTog] = useState(false)
  const openToggle = () => {
    setTog(!tog)
  }
  useEffect(() => {
    setTog(false)
  }, [currencyType, language])
  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setTog(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  return (
    <>
      <button
        className="nav-menu nav-menu-icon-wrap"
        onClick={() => {
          setShowModal((prev) => !prev)
          ;
          setTog(false)
          !isMobile ? propssetTog(false) : null
        }}
      >
        {showModal ? (
          <CloseIcon className="menu-icon" color={whiteIcon && "white"} />
        ) : (
          <BarsIcon className="menu-icon" color={whiteIcon && "white"} />
        )}
      </button>
      <Offcanvas
        className="burger-menu-wrap"
        placement="top"
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop={false}
      >
        <Offcanvas.Header className="burger-header">
          <Link to="/" className="logo">
            <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={whiteIcon ? logoWhite : logo} alt="Provident Estate" />
          </Link>
          <div ref={wrapperRef} className="dev-to d-block d-md-none">
            <div className="dev-toggle" onClick={() => openToggle()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.4107 11.1607L16.4652 10.2152C16.3226 10.0726 16.2041 9.90811 16.1139 9.72785L15.2139 7.92775C15.1087 7.71732 14.8282 7.6718 14.6618 7.83817C14.4848 8.0152 14.2257 8.08234 13.985 8.01356L12.9242 7.71049C12.5214 7.59539 12.1033 7.83687 12.0017 8.24333C11.9257 8.54718 12.049 8.86597 12.3095 9.0397L12.7985 9.36566C13.2907 9.69383 13.3597 10.3903 12.9414 10.8086L12.7746 10.9754C12.5988 11.1512 12.5 11.3897 12.5 11.6383V11.9807C12.5 12.3205 12.4076 12.6539 12.2328 12.9453L11.1373 14.7712C10.8195 15.3009 10.247 15.625 9.6293 15.625C9.14368 15.625 8.75 15.2313 8.75 14.7457V13.7694C8.75 13.0027 8.28322 12.3133 7.57136 12.0285L7.02624 11.8105C6.20812 11.4832 5.72825 10.6305 5.87311 9.76135L5.87897 9.72616C5.91765 9.49413 5.99964 9.27144 6.12066 9.06973L6.19517 8.94555C6.60286 8.26607 7.39368 7.91624 8.17069 8.07164L9.15223 8.26795C9.63113 8.36373 10.1033 8.0758 10.2375 7.6062L10.4113 6.99812C10.5352 6.56434 10.3326 6.1038 9.92909 5.90204L9.375 5.625L9.29917 5.70083C8.94754 6.05246 8.47063 6.25 7.97335 6.25H7.82258C7.61603 6.25 7.41746 6.33254 7.27141 6.47859C7.03519 6.71481 6.67345 6.77423 6.37465 6.62483C5.97027 6.42264 5.82361 5.91899 6.05622 5.53131L7.2328 3.57033C7.3502 3.37467 7.43041 3.16006 7.47044 2.93728M17.4107 11.1607C17.4695 10.7824 17.5 10.3948 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C9.11236 2.5 8.26073 2.6542 7.47044 2.93728M17.4107 11.1607C16.8528 14.7517 13.7474 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 6.74551 4.57291 3.97517 7.47044 2.93728"
                  stroke="#9399A4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className={tog ? "active" : ""}>
                {/* {language?.value}/ */}
                {currencyType?.value}
              </span>
              {tog ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M3 10.5L8 5.5L13 10.5"
                    stroke="#9399A4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M13 5.5L8 10.5L3 5.5"
                    stroke="#9399A4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
            {tog && (
              <div className="dev-to-open">
                <div className="label">Currency</div>
                <CurrencyTypeSelect isburger setShowModal={setShowModal} setTog={setTog} tog={tog} />
                <div className="mt-3"></div>
                <SizeTypeSelector isburger setShowModal={setShowModal} setTog={setTog} tog={tog} />
                {/* <div className="label">Language</div>
               <LanguageTypeSelect isburger setShowModal={setShowModal} setTog={setTog} tog={tog} /> */}

              </div>
            )}
          </div>
          <button
            className="nav-menu nav-menu-icon-wrap"
            onClick={() => setShowModal((prev) => !prev)}
          >
            {showModal ? (
              <CloseIcon className="menu-icon" color={whiteIcon && "white"} />
            ) : (
              <BarsIcon className="menu-icon" color={whiteIcon && "white"} />
            )}
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="burger-menu-section container">
          <div className="burger-body">
            <Accordion>
              <Accordion.Item>
                <Accordion.Header
                  as="div"
                  className={"no-ctas"}
                >
                  <Link to={process.env.GATSBY_MYACCOUNT_URL} className="my-account-user main-menu">
                    {isAuthenticated ? <UserIconLogged className="user-icon"
                      color={isTransparent ? "white" : transparentScroll ? "#07234B" : "#07234B"}
                      isAuthenticated={isAuthenticated} /> :
                      <UserIcon
                        className="user-icon"
                        color={isTransparent ? "white" : transparentScroll ? "#07234B" : "#07234B"}
                        isAuthenticated={isAuthenticated}
                      />}
                    {isAuthenticated ? capitalize(userData?.name) : "Sign in / Register"}
                  </Link>
                </Accordion.Header>
              </Accordion.Item>
              {links.map((menu) => {
                const { main_menu, sub_menu_cta, id, sub_menu_bottom } = menu

                let hasCTAs = false

                if (!isEmpty(sub_menu_cta)) {
                  if (!isEmpty(sub_menu_cta)) hasCTAs = true
                }

                return (
                  <Accordion.Item eventKey={id} key={id}>
                    <Accordion.Header
                      as="div"
                      className={hasCTAs ? "has-ctas" : "no-ctas"}
                    >
                      <CTALink
                        cta={main_menu}
                        className="main-menu"
                        key={`menu-${id}`}
                        onClick={() => {
                          setShowModal(false)
                        }}
                        alsoLabel
                      />
                    </Accordion.Header>
                    {hasCTAs && (
                      <Accordion.Body>
                        {/* {menu?.isoffplan && menu?.top_title && <p className="heading">{menu.top_title}</p>} */}
                        {sub_menu_cta?.map((cta) => (
                          <CTALink
                            cta={cta}
                            className="sub-menu"
                            key={cta.id}
                            onClick={() => {
                              setShowModal(false)
                            }}
                          />
                        ))}
                        {menu.sub_menu_bot_title && <p className="heading">{menu.sub_menu_bot_title}</p>}
                        {!isEmpty(sub_menu_bottom) && (
                          sub_menu_bottom?.map((cta) => (
                            <CTALink
                              cta={cta}
                              className="sub-menu"
                              key={cta.id}
                              onClick={() => {
                                setShowModal(false)
                              }}
                            />
                          ))
                        )}
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                )
              })}
            </Accordion>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default BurgerMenu
